var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound-container"},[_c('img',{staticClass:"notfound-img",attrs:{"src":_vm.notFoundImg}}),_c('p',{staticClass:"notfound-tips"},[_vm._v("您访问的页面走丢了")])])}
var staticRenderFns = []

export { render, staticRenderFns }